import React, { FC, useEffect, useState } from "react";
import { Checkbox, FormControlLabel, Grid, Tab, Tabs } from "@mui/material";
import FormField from "../../../../../components/common/FormField";
import {
  surveyCollectionSummaryFields,
  surveyDeliverySummaryFields,
} from "../surveyUtils";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setNewSurveySummaryLocal } from "../../../../../store/reducers/leadSurveySlice";
import {
  checkValidPostcodeAction,
  setCheckValidPostcodeAction,
} from "../../../../../store/reducers/mmymSlice";
import {
  getCountyOptionsByCountry,
  leadCountryOptions,
} from "../../leadAllFields";

const DEFAULT_PROPERTY_TYPES = [
  "Unknown",
  "House",
  "Town House",
  "Mainsonette",
  "Flat",
  "Bungalow",
  "Cottage",
  "Self Store",
  "Commercial",
];

interface ManageDeliveryFormProps {
  // checkValidator?: any;
  // resetValidator?: any;
  // error?: any;
  disabledAction?: boolean;
  setCountryCode?: any;
  countryCode?: any;
}

const DeliverySummaryForm: FC<ManageDeliveryFormProps> = ({
  // checkValidator,
  // resetValidator,
  // error,
  disabledAction,
  setCountryCode,
  countryCode,
}) => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(0);
  const [postCodeSelected, setPostCodeSelected] = useState("");
  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const {
    surveyedSummary,
    newSurveySummary,
    isSurveySummarySuccess,
    isCompleteSurveyedSummarySuccess,
    propertyTypeList,
  } = useSelector((state: any) => state.leadSurvey);

  // Handle input changes
  const onChangeAction = (event: any, valueFormat?: any, index?: number) => {
    const { id, value, checked, type } = event.target;
    const updatedMovingTo = [...(newSurveySummary?.movingTo || [])];

    if (typeof index === "number" && index >= 0) {
      if (type === "checkbox") {
        updatedMovingTo[index] = {
          ...updatedMovingTo[index],
          [id]: checked,
        };
      } else {
        updatedMovingTo[index] = {
          ...updatedMovingTo[index],
          [id]:
            id === "postcode" ? (value ? value.toUpperCase() : value) : value,
        };
      }
    }

    dispatch(
      setNewSurveySummaryLocal({
        ...newSurveySummary,
        movingTo: updatedMovingTo,
      })
    );

    // resetValidator(id);
  };

  const [postcodeToValidate, setPostcodeToValidate] = useState<{
    index: number;
    postcode: string;
  } | null>(null);

  // Handle blur action
  const onBlurAction = (e: any) => {
    const { id, value } = e.target;
    // checkValidator(id);
    if (e.target.id === "postcode" && e.target.value.trim() !== "") {
      setPostcodeToValidate({
        index: activeTab,
        postcode: value.trim(),
      });
    }
  };

  useEffect(() => {
    if (postcodeToValidate) {
      const { postcode } = postcodeToValidate;

      if (postcode.length > 5) {
        dispatch(checkValidPostcodeAction(postcode));
      } else {
        dispatch(setCheckValidPostcodeAction(false));
      }

      setPostcodeToValidate(null);
    }
  }, [postcodeToValidate, dispatch]);

  // Use shared function for county options
  const getCountyOptions = getCountyOptionsByCountry;

  const getPropertyTypeOptions = (index: number) => {
    const configuredPropertyTypes = Array.isArray(propertyTypeList)
      ? propertyTypeList
          .map((item: any) => item?.name)
          .filter((name: any) => typeof name === "string" && name.trim() !== "")
      : [];

    const baseOptions =
      configuredPropertyTypes.length > 0
        ? configuredPropertyTypes
        : DEFAULT_PROPERTY_TYPES;

    const savedTypeName = newSurveySummary?.movingTo?.[index]?.type;
    const hasSavedTypeInOptions =
      typeof savedTypeName === "string" &&
      baseOptions.some(
        (option: string) => option.toLowerCase() === savedTypeName.toLowerCase(),
      );

    if (
      typeof savedTypeName === "string" &&
      savedTypeName.trim() !== "" &&
      !hasSavedTypeInOptions
    ) {
      return [...baseOptions, savedTypeName];
    }

    return baseOptions;
  };

  return (
    <>
      <Grid
        container
        spacing={0.5}
        sx={{
          padding: "0px",
          borderRadius: "5px",
          overflow: "hidden",
          border: "1px solid #CFCFCF",
        }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          style={{
            paddingLeft: "0px !important",
            background: "#E5F4F1",
            paddingBottom: "6px",
          }}
        >
          <Tabs
            value={activeTab}
            onChange={handleChangeTab}
            aria-label="Delivery Address Tabs"
            TabIndicatorProps={{ style: { display: "none" } }} // Hide the tab indicator line
            sx={{
              minHeight: "16px",
              "& .MuiTabs-flexContainer": {
                gap: 1, // adds space between tabs (theme.spacing(1))
              },
              "& .MuiTab-root": {
                minHeight: "30px", // affects all Tab children
                // height: "30px",
                padding: "3px 2px 0px 2px",
                textTransform: "capitalize",
                fontWeight: 600,
                // color: "#333333",
                justifyContent: "flex-start",
                alignItems: "center",
              },
            }}
          >
            {newSurveySummary?.movingTo?.map((address: any, index: number) => (
              <Tab
                sx={{
                  textAlign: "left",
                  paddingTop: "6px !important",
                  fontWeight: 600,
                  color: "#333333",
                  marginRight: "10px",
                  backgroundColor:
                    activeTab === index ? "#ffffff" : "transparent",
                  borderRadius: "5px",
                  minHeight: "30px !important",
                  paddingLeft: "6px !important",
                  marginTop: "2px",
                  marginBottom: "0px",
                }}
                key={index}
                label={
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span style={{ marginRight: 4 }}>{`Delivery ${
                      index + 1
                    }`}</span>
                  </div>
                }
              />
            ))}
          </Tabs>
        </Grid>
        {newSurveySummary?.movingTo?.map((address: any, index: number) => (
          <Grid
            item
            xs={12}
            key={index}
            role="tabpanel"
            hidden={activeTab !== index} // Hide tabs based on the activeTab value
            id={`tab-panel-${index}`}
            aria-labelledby={`tab-${index}`}
            sx={{ background: "#fff", padding: "6px 10px 10px 6px !important", }}
          >
            {activeTab === index && (
              <Grid container spacing={0.5}>
                {surveyDeliverySummaryFields?.map((field, i) => {
                  return (
                    <>
                      {field?.type === "checkbox" ? (
                        <Grid
                          item
                          xs={12}
                          md={field?.md ? field?.md : 1}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            textAlign: "center",
                            paddingTop: "0px !important",
                          }}
                        >
                          <FormControlLabel
                            control={
                              <Checkbox
                                disabled={disabledAction}
                                checked={
                                  newSurveySummary
                                    ? newSurveySummary?.movingTo?.[activeTab]?.[
                                        field?.id
                                      ]
                                    : ""
                                }
                                onChange={(e: any) =>
                                  onChangeAction(e, null, activeTab)
                                }
                                name={field?.id}
                                id={field?.id}
                                color="primary"
                              />
                            }
                            label="Verified"
                          />
                        </Grid>
                      ) : (
                        <FormField
                          key={i}
                           onPaste={(e: any) =>  field?.isPaste ? '' : e.preventDefault()}
                          onKeyDown={(event: any) => {
                            if (
                              event.keyCode === 8 ||
                              event.keyCode === 9 ||
                              event.keyCode === 37 ||
                              event.keyCode === 38 ||
                              event.keyCode === 39 ||
                              event.keyCode === 40 ||
                              event.keyCode === 18 ||
                              event.keyCode === 17 ||
                              event.ctrlKey
                            )
                              return;

                            if (
                              field?.patternAllowed &&
                              !field?.patternAllowed.test(event.key)
                            ) {
                              event.preventDefault();
                            } else if (
                              field?.patternAllowed &&
                              !field?.patternAllowed.test(
                                event.target.value + event.key
                              )
                            ) {
                              event.preventDefault();
                            }
                          }}
                          {...{
                            ...field,
                            multiline: true,
                            minDate:
                              field.id === "removalDate"
                                ? new Date()
                                : undefined,
                            editReadOnly: disabledAction,
                            inSingleGridForm: true,
                            disabled:
                              field?.id === "removal" ? true : disabledAction,
                            marginTopCountryCode: "2px",
                             GridFieldStyle: {
                              paddingRight:
                                i % 2 === 0 || field?.id === "bedrooms"
                                  ? "4px"
                                  : "0px",
                            },
                            onCountryCodeChange:
                              field.type === "contact" // Example of checking if it's a country code field
                                ? (code: string) => setCountryCode(code)
                                : undefined,
                            ...{
                              ...(field?.type === "contact" && {
                                countryCode: newSurveySummary[field.id]
                                  ? countryCode
                                  : "",
                              }),
                            },
                            value:
                              newSurveySummary?.movingTo?.[activeTab]?.[
                                field?.id
                              ] || "",

                            ...{
                              variant: "outlined", // Adding this variant prop
                              options:
                                field.id === "county"
                                  ? getCountyOptions(
                                      newSurveySummary?.movingTo?.[activeTab]?.country,
                                    )
                                  : field.id === "country"
                                    ? leadCountryOptions
                                    : field.id === "type"
                                      ? getPropertyTypeOptions(activeTab)
                                      : field.options, // Conditional options for county/country/type
                              onChange: (e: any) =>
                                onChangeAction(e, null, activeTab),
                              onBlur: onBlurAction,
                              isNonMarginTop: true,
                              InputProps: {
                                ...(field?.inputProps && field?.inputProps),
                                ...{
                                  disabled:
                                    field?.editReadOnly || disabledAction,
                                },

                                sx:
                                  field?.type === "text" ||
                                  field?.type === "password"
                                    ? {
                                        height: "36px",
                                        padding: "10px 0px 6px 4px",
                                      }
                                    : field?.type === "contact"
                                    ? {
                                        height: "36px",
                                        padding: "16px 0px 6px 4px !important",
                                      }
                                    : { padding: "10px 4px", height: "36px" },
                              },
                            },
                            // error: error && error[field?.id],
                          }}
                        />
                      )}
                    </>
                  );
                })}
              </Grid>
            )}
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default DeliverySummaryForm;
